import { emailLogApis } from '@shared/apis';
import { genericMutationWithId, genericQueryWithId, genericQueryWithParams } from './generics';

export const useSearchEmails = genericQueryWithParams<emailLogApis.SearchEmails>(
  emailLogApis.searchEmails
);

export const useGetEmail = genericQueryWithId<emailLogApis.GetEmail>(emailLogApis.getEmail);

export const useSearchEmailPeople = genericQueryWithParams<emailLogApis.SearchEmailPeople>(
  emailLogApis.searchEmailPeople
);

export const useResendEmail = genericMutationWithId<emailLogApis.ResendEmail>(
  emailLogApis.resendEmail,
  emailLogApis.searchEmails.endpoint,
  emailLogApis.getEmail.endpoint
);
